import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Drawer, Table, Collapse, Button } from 'antd';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { getCfColumns, getCFTypeDataHelper, getCFTypeLoadingHelper } from '@Components/Admin/AdminConfiguration/CustomInputsV3/helpers';
import FormCustomFieldV3 from './FormCustomFieldV3';
import FormAddEntity from './FormCustomFieldV3/FormAddEntity';
import './style.scss';

const { Panel } = Collapse;

const CustomInputsV3 = (props) => {
  const { getCFV2, user, deleteCFV2Loading, type, cfGlobal } = props;
  const [showCreateCF, setShowCreateCF] = useState(false);
  const [showUpdateCF, setShowUpdateCF] = useState(false);
  const [showAddField, setShowAddField] = useState(false);
  const [selectedCFV2, setSelectedCFV2] = useState(null);
  const [isDocField, setIsDocField] = useState(false);
  const [call, setCall] = useState(false);

  useEffect(() => {
    const payload = {
      orgId: user?.tenant_info?.org_id,
      cfV2Id: null,
      activeOnly: true,
      isGlobal: true,
    };
    if (type) {
      getCFV2({
        ...payload,
        entityName: type,
        isGlobal: false,
      });
    }
    getCFV2(payload);
  }, [call]);

  useEffect(() => {
    if (showCreateCF) {
      setSelectedCFV2(null);
    }
  }, [showCreateCF]);

  const onUpdateCfRow = (record) => {
    setShowUpdateCF(true);
    setSelectedCFV2(record);
    if (record?.isDocField) setIsDocField(true);
    else setIsDocField(false);
  };
  const getCFTypeData = (entityTypes) => getCFTypeDataHelper(entityTypes, props);

  const getCFTypeLoading = (entityTypes) => getCFTypeLoadingHelper(entityTypes, props);

  const getDocumentLineData = () => {
    const data = getCFTypeData(type)?.data?.document_line_custom_fields?.map((item) => ({
      ...item,
      isDocField: false,
    })) || [];
    return data;
  };

  const getTags = () => {
    const data = getCFTypeData(type)?.data?.document_line_custom_fields
      ?.map((item) => ({
        id: item?.cf_id,
        value: item?.field_name,
        title: item?.field_name,
        text: item?.field_name,
        field_type: item?.field_type,
      }));
    return data;
  };

  return (
    <Fragment>
      {/* Drawer to add new custom field to an entity */}
      <Drawer
        open={showAddField}
        width="460px"
        mask
        onClose={() => {
          setShowAddField(false);
          setIsDocField(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '415px' }}>
            <H3Text text={isDocField ? 'Add document custom field' : 'Add document line custom field'} className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowAddField(false);
                setIsDocField(false);
              }}
            />
          </div>
        </div>
        <div>
          <FormAddEntity
            tags={(isDocField ? cfGlobal?.data?.document_custom_fields : cfGlobal?.data?.document_line_custom_fields)
              ?.map((item) => ({
                id: item?.cf_id,
                value: item?.field_name,
                title: item?.field_name,
                text: item?.field_name,
                field_type: item?.field_type,
              }))}
            entity={isDocField ? type : `${type}_LINE`}
            callback={() => {
              setShowAddField(false);
              setCall(!call);
            }}
            isDocField={isDocField}
            cfCurrent={isDocField ? (getCFTypeData(type)?.data?.document_custom_fields || []) : (getCFTypeData(type)?.data?.document_line_custom_fields || [])}
            cfData={isDocField ? getCFTypeData(type)?.data?.document_custom_fields : getCFTypeData(type)?.data?.document_line_custom_fields}
          />
        </div>
      </Drawer>

      {/* Drawer to create new custom field */}
      <Drawer
        open={showCreateCF}
        width="660px"
        mask
        onClose={() => {
          setShowCreateCF(false);
          setIsDocField(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '615px' }}>
            <H3Text text={isDocField ? 'Add document custom field' : 'Add new document line custom field'} className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowCreateCF(false);
                setIsDocField(false);
              }}
            />
          </div>
        </div>
        <div>
          <FormCustomFieldV3
            isLineField={!isDocField}
            entity={isDocField ? type : `${type}_LINE`}
            callback={() => {
              setShowCreateCF(false);
              setCall(!call);
              setIsDocField(false);
            }}
            selectedCFV2={selectedCFV2}
            availableEntities={isDocField ? getCFTypeData(type)?.data?.available_document_entities : getCFTypeData(type)?.data?.available_document_line_entities}
            tags={getTags()}
            cfData={isDocField ? getCFTypeData(type)?.data?.document_custom_fields : getCFTypeData(type)?.data?.document_line_custom_fields}
          />
        </div>
      </Drawer>

      {/* Drawer to update existing custom field */}
      <Drawer
        open={showUpdateCF}
        width="660px"
        mask
        onClose={() => {
          setShowUpdateCF(false);
          setIsDocField(false);
        }}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '615px' }}>
            <H3Text text={isDocField ? 'Update document custom field' : 'Update document line custom field'} className="custom-drawer__title" />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowUpdateCF(false);
                setIsDocField(false);
                setSelectedCFV2(null);
              }}
            />
          </div>
        </div>
        <div>
          <FormCustomFieldV3
            isLineField={!isDocField}
            callback={() => {
              setShowUpdateCF(false);
              setCall(!call);
              setIsDocField(false);
            }}
            entity={isDocField ? type : `${type}_LINE`}
            selectedCFV2={selectedCFV2}
            availableEntities={isDocField ? getCFTypeData(type)?.data?.available_document_entities : getCFTypeData(type)?.data?.available_document_line_entities}
            tags={getTags()}
            cfData={isDocField ? getCFTypeData(type)?.data?.document_custom_fields : getCFTypeData(type)?.data?.document_line_custom_fields}
          />
        </div>
      </Drawer>
      <div className="ant-row">
        <div className="ant-col-md-24">
          {!['PRODUCTS', 'BILL_OF_MATERIAL', 'BATCH']?.includes(type) && (
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              expandIcon={({ isActive }) => (isActive ? <FontAwesomeIcon icon={faAngleDown} />
                : <FontAwesomeIcon icon={faAngleRight} />)}
              style={{
                background: '#00000005',
                marginBottom: '10px',
              }}
            >
              <Panel
                header={(
                  <div className="view-fg-v2__step-header">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                      {`${getCFTypeData(type)?.data?.document_custom_fields?.length || '0'} Document Fields`}
                      <Button
                        type="primary"
                        size="small"
                        onClick={() => {
                          if (type) {
                            setShowAddField(true);
                          } else {
                            setShowCreateCF(true);
                          }
                          setIsDocField(true);
                        }}
                      >
                        + New Field
                      </Button>
                    </div>
                  </div>
                )}
                key="1"
              >
                <Table
                  columns={getCfColumns(onUpdateCfRow)}
                  size="small"
                  scroll="scroll"
                  loading={getCFTypeLoading(type) || deleteCFV2Loading}
                  dataSource={getCFTypeData(type)?.data?.document_custom_fields?.map((item) => ({
                    ...item,
                    isDocField: true,
                  })) || []}
                  pagination={{
                    pageSize: 5,
                    showSizeChanger: false,
                  }}
                />
              </Panel>
            </Collapse>
          )}
          {(['PRODUCTS', 'PURCHASE_ORDERS', 'SALES_ESTIMATE', 'SALES_ORDER', 'PACKING_SLIP', 'INVOICE', 'BILL_OF_MATERIAL', 'MANUFACTURING_ORDER', 'PURCHASE_REQUEST', 'STOCK_TRANSFER', 'GOOD_RECEIVING_NOTES', 'ACCOUNT_PAYABLE_INVOICE', 'BATCH', 'CONSUMPTION_ORDER', 'ANNUAL_MAINTENANCE_CONTRACT', 'PURCHASE_INDENT', 'DELIVERY_CHALLAN', 'RETURN_SLIP']?.includes(type) || !type) && (
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              expandIcon={({ isActive }) => (isActive ? <FontAwesomeIcon icon={faAngleDown} />
                : <FontAwesomeIcon icon={faAngleRight} />)}
              style={{
                background: '#00000005',
              }}
            >
              <Panel
                header={(
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    {`${getCFTypeData(type)?.data?.document_line_custom_fields?.length || '0'} Document Line Fields`}
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => {
                        if (type) {
                          setShowAddField(true);
                        } else {
                          setShowCreateCF(true);
                        }
                        setIsDocField(false);
                      }}
                    >
                      + New Field
                    </Button>
                  </div>
                )}
                key="1"
              >
                <Table
                  columns={getCfColumns(onUpdateCfRow)}
                  size="small"
                  scroll="scroll"
                  loading={getCFTypeLoading(type) || deleteCFV2Loading}
                  dataSource={getDocumentLineData()}
                  pagination={{
                    pageSize: 5,
                    showSizeChanger: false,
                  }}
                />
              </Panel>
            </Collapse>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CFV2Reducers }) => ({
  user: UserReducers.user,
  deleteCFV2Loading: CFV2Reducers.deleteCFV2Loading,
  cfV2Products: CFV2Reducers.cfV2Products,
  cfV2StockAdjustment: CFV2Reducers.cfV2StockAdjustment,
  cfV2Vendors: CFV2Reducers.cfV2Vendors,
  cfV2DeliveryChallan: CFV2Reducers.cfV2DeliveryChallan,
  cfV2BillOfMaterial: CFV2Reducers.cfV2BillOfMaterial,
  cfV2StockTransfer: CFV2Reducers.cfV2StockTransfer,
  cfV2customerPayment: CFV2Reducers.cfV2customerPayment,
  cfV2VendorPayout: CFV2Reducers.cfV2VendorPayout,
  cfV2SalesEstimate: CFV2Reducers.cfV2SalesEstimate,
  cfV2SalesOrder: CFV2Reducers.cfV2SalesOrder,
  cfV2PackingSlip: CFV2Reducers.cfV2PackingSlip,
  cfV2ManufacturingOrder: CFV2Reducers.cfV2ManufacturingOrder,
  cfV2DebitNote: CFV2Reducers.cfV2DebitNote,
  cfV2GoodReceivingNotes: CFV2Reducers.cfV2GoodReceivingNotes,
  cfV2PurchaseOrders: CFV2Reducers.cfV2PurchaseOrders,
  cfV2PurchaseRequest: CFV2Reducers.cfV2PurchaseRequest,
  cfV2PurchaseIndent: CFV2Reducers.cfV2PurchaseIndent,
  cfV2CreditNote: CFV2Reducers.cfV2CreditNote,
  cfV2customers: CFV2Reducers.cfV2customers,
  cfV2Invoice: CFV2Reducers.cfV2Invoice,
  cfV2Batch: CFV2Reducers.cfV2Batch,
  cfV2DocConsumption: CFV2Reducers.cfV2DocConsumption,
  globalCfV2: CFV2Reducers.globalCfV2,
  cfV2APInvoice: CFV2Reducers.cfV2APInvoice,
  getCFV2ProductsLoading: CFV2Reducers.getCFV2ProductsLoading,
  getCFV2StockAdjustmentLoading: CFV2Reducers.getCFV2StockAdjustmentLoading,
  getCFV2VendorsLoading: CFV2Reducers.getCFV2VendorsLoading,
  getCFV2DeliveryChallanLoading: CFV2Reducers.getCFV2DeliveryChallanLoading,
  getCFV2BillOfMaterialLoading: CFV2Reducers.getCFV2BillOfMaterialLoading,
  getCFV2StockTransferLoading: CFV2Reducers.getCFV2StockTransferLoading,
  getCFV2customerPaymentLoading: CFV2Reducers.getCFV2customerPaymentLoading,
  getCFV2VendorPayoutLoading: CFV2Reducers.getCFV2VendorPayoutLoading,
  getCFV2SalesEstimateLoading: CFV2Reducers.getCFV2SalesEstimateLoading,
  getCFV2SalesOrderLoading: CFV2Reducers.getCFV2SalesOrderLoading,
  getCFV2PackingSlipLoading: CFV2Reducers.getCFV2PackingSlipLoading,
  cfV2GateDocument: CFV2Reducers.cfV2GateDocument,
  getCFV2GateDocumentLoading: CFV2Reducers.getCFV2GateDocumentLoading,
  getCFV2ManufacturingOrderLoading: CFV2Reducers.getCFV2ManufacturingOrderLoading,
  getCFV2DebitNoteLoading: CFV2Reducers.getCFV2DebitNoteLoading,
  getCFV2GoodReceivingNotesLoading: CFV2Reducers.getCFV2GoodReceivingNotesLoading,
  getCFV2PurchaseOrdersLoading: CFV2Reducers.getCFV2PurchaseOrdersLoading,
  getCFV2PurchaseRequestLoading: CFV2Reducers.getCFV2PurchaseRequestLoading,
  getCFV2PurchaseIndentLoading: CFV2Reducers.getCFV2PurchaseIndentLoading,
  getCFV2CreditNoteLoading: CFV2Reducers.getCFV2CreditNoteLoading,
  getCFV2customersLoading: CFV2Reducers.getCFV2customersLoading,
  getCFV2InvoiceLoading: CFV2Reducers.getCFV2InvoiceLoading,
  getCFV2BatchLoading: CFV2Reducers.getCFV2BatchLoading,
  getDocCFV2ConsumptionLoading: CFV2Reducers.getDocCFV2ConsumptionLoading,
  getDocCFV2AnnualContractMaintenanceLoading: CFV2Reducers.getDocCFV2AnnualContractMaintenanceLoading,
  getDocCFV2ReturnSlipLoading: CFV2Reducers.getDocCFV2ReturnSlipLoading,
  globalCfV2Loading: CFV2Reducers.globalCfV2Loading,
  cfGlobal: CFV2Reducers.cfGlobal,
  cfV2AnnualMaintenanceContract: CFV2Reducers.cfV2AnnualMaintenanceContract,
  cfV2ReturnSlip: CFV2Reducers.cfV2ReturnSlip,
  getCFV2APInvoiceLoading: CFV2Reducers.getCFV2APInvoiceLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCFV2: (payload, callback) => dispatch(CFV2Actions.getCFV2(payload, callback)),
  deleteCFV2: (orgId, cfId, callback) => dispatch(CFV2Actions.deleteCFV2(orgId, cfId, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomInputsV3));
